import angular from 'angular'

import { $q, $window } from '../ng-compat/imports'

/**
 * Intercepts $http response errors and redirects to the specified redirect.
 * In some cases the backend will enforce the user is redirected somewhere.
 * For example when mandating MFA. When doing fetch requests, duke will
 * return a JSON response with the location of where to redirec to.
 * This intercepts that and does the redirection.
 *
 * @module webregister.http.RedirectOnRedirect
 */
function redirectOnRedirect() {
  let _hasEncounteredRedirect = false

  return {
    hasEncounteredRedirect() {
      return _hasEncounteredRedirect
    },

    responseError(response: $TSFixMe) {
      if (
        response.status === 302 &&
        response.headers('Content-Type') === 'application/json'
      ) {
        _hasEncounteredRedirect = true
        $window.location.href = response.data.redirect_url
      }

      return $q.reject(response)
    },
  }
}

angular
  .module('webregister.http')
  .factory('redirectOnRedirect', redirectOnRedirect)
